import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { SectionComponent } from './section.component';

@NgModule({
    imports: [CommonModule, BrowserAnimationsModule],
    declarations: [SectionComponent],
    exports: [SectionComponent]
})
export class SectionModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/section/section.module.ts